export const INTERNAL_MESSAGE_COST_CENTS = 2;
export const INTERNAL_PRODUCT_COST_CENTS = 3;

const usageCount = (value) => {
  const count = Number(value ?? 0);
  return Number.isFinite(count) && count > 0 ? count : 0;
};

export const calculateInternalUsageCosts = (usage) => {
  const messageCents = usageCount(usage?.chatMessagesCount) * INTERNAL_MESSAGE_COST_CENTS;
  const productCents = usageCount(usage?.productUpdatesCount) * INTERNAL_PRODUCT_COST_CENTS;
  return {
    chatMessagesCost: messageCents / 100,
    productUpdatesCost: productCents / 100,
    totalCost: (messageCents + productCents) / 100,
  };
};
